const DB_NAME = 'rest-cache-db'
const STORE = 'rest'

const openDB = () => {
	return new Promise((resolve, reject) => {
		const req = indexedDB.open(DB_NAME, 1)
		req.onupgradeneeded = () => {
			const db = req.result
			if (!db.objectStoreNames.contains(STORE)) {
				db.createObjectStore(STORE, { keyPath: 'key' })
			}
		}
		req.onsuccess = () => resolve(req.result)
		req.onerror = () => reject(req.error)
	})
}

const store = (db, mode = 'readonly') => {
	return db.transaction(STORE, mode).objectStore(STORE)
}

const stableStringify = (v) => {
	if (v === null || v === undefined) return ''
	if (typeof v !== 'object') return JSON.stringify(v)
	if (Array.isArray(v)) return '[' + v.map(stableStringify).join(',') + ']'
	const keys = Object.keys(v).sort()
	return '{' + keys.map(k => JSON.stringify(k) + ':' + stableStringify(v[k])).join(',') + '}'
}

const buildKey = ({ method, url, params, data }) => {
	return [
		method.toUpperCase(),
		url,
		'p=' + stableStringify(params),
		'd=' + stableStringify(data),
	].join('|')
}

const idbGet = async (key) => {
	const db = await openDB()
	return new Promise((resolve, reject) => {
		const req = store(db).get(key)
		req.onsuccess = () => resolve(req.result || null)
		req.onerror = () => reject(req.error)
	})
}

const idbPut = async (record) => {
	const db = await openDB()
	return new Promise((resolve, reject) => {
		const req = store(db, 'readwrite').put(record)
		req.onsuccess = () => resolve(true)
		req.onerror = () => reject(req.error)
	})
}

const idbClearAll = async () => {
	const db = await openDB()
	return new Promise((resolve, reject) => {
		const req = store(db, 'readwrite').clear()
		req.onsuccess = () => resolve(true)
		req.onerror = () => reject(req.error)
	})
}

export const axiosIDBCache = (axiosInstance) => {
	return {
		async request(config) {
			const cfg = typeof config === 'string' ? { url: config } : (config || {})
			const method = (cfg.method || 'GET').toUpperCase()

			const key = buildKey({
				method,
				url: cfg.url,
				params: cfg.params,
				data: cfg.data,
			})

			if (cfg.cache === true) {
				const cached = await idbGet(key)
				if (cached) return cached.res

				const resp = await axiosInstance(cfg)
				const data = resp?.data ?? resp
				try {
					await idbPut({
						key,
						req: { method, url: cfg.url, params: cfg.params ?? null, data: cfg.data ?? null },
						res: data,
						time: Date.now(),
					})
				} catch {
				}
				return data
			}

			if (cfg.cache === false) {
				const resp = await axiosInstance(cfg)
				const data = resp?.data ?? resp
				try {
					await idbPut({
						key,
						req: { method, url: cfg.url, params: cfg.params ?? null, data: cfg.data ?? null },
						res: data,
						time: Date.now(),
					})
				} catch {
				}
				return data
			}

			const resp = await axiosInstance(cfg)
			return resp?.data ?? resp
		},

		async cacheClearAll() {
			await idbClearAll()
		},

		async setupCacheAutoClearOnReload() {
			try {
				const nav = performance.getEntriesByType('navigation')[0]
				if (nav && nav.type === 'reload') {
					await idbClearAll()
				} else if (performance && performance.navigation && performance.navigation.type === 1) {
					await idbClearAll()
				}
			} catch {
			}
		},
	}
}
